"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("pixi-spine");
var placeholder_slot_1 = require("../utilities/placeholder-slot");
var customize_1 = require("../models/customize");
var color_filter_1 = __importDefault(require("../utilities/color-filter"));
var random_1 = require("../utilities/random");
var SLOT_TYPE = {
    BODY: "body",
    EYE: "eye",
    DIRT: "dirt"
};
var DragonContainer = /** @class */ (function (_super) {
    __extends(DragonContainer, _super);
    function DragonContainer(resources) {
        var _this = _super.call(this) || this;
        _this._resources = resources;
        _this._dirty = false;
        return _this;
    }
    Object.defineProperty(DragonContainer.prototype, "spine", {
        get: function () {
            if (!this._spine) {
                this._spine = new PIXI.spine.Spine(this._resources.dragon.spineData);
                this.addChild(this._spine);
                // Load slots
                this.breathSlot;
            }
            return this._spine;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragonContainer.prototype, "breathSlot", {
        get: function () {
            if (!this._breathSlot) {
                this._breathSlot = (0, placeholder_slot_1.adaptPlaceholderSlot)("breath", this.spine);
            }
            return this._breathSlot;
        },
        enumerable: false,
        configurable: true
    });
    DragonContainer.prototype.getMouthPosition = function () {
        var mouth = this.spine.skeleton.findBone("mouth");
        var local = new PIXI.spine.core.Vector2(0, 0);
        var vector = mouth.localToWorld(local);
        return new PIXI.Point(vector.x, vector.y);
    };
    DragonContainer.prototype.configureAppearance = function (quitDay, body, eyes, head, scales, tail, wings, hat, collar, band, dirty, disappointed) {
        if (quitDay == this._quitDay && body == this._body && eyes == this._eyes && head == this._head && scales == this._scales && tail == this._tail && wings == this._wings && hat == this._hat && collar == this._collar && band == this._band && this._dirty == dirty && this._disappointed == disappointed) {
            return;
        }
        this._quitDay = quitDay;
        this._body = body;
        this._eyes = eyes;
        this._head = head;
        this._scales = scales;
        this._tail = tail;
        this._wings = wings;
        this._hat = hat;
        this._collar = collar;
        this._band = band;
        this._dirty = dirty;
        this._disappointed = disappointed;
        var skin = new PIXI.spine.core.Skin("skin");
        skin.addSkin(this.spine.skeleton.data.findSkin("egg_crack/egg_crack_day_" + Math.min(Math.max(quitDay, -5), -1)));
        skin.addSkin(this.spine.skeleton.data.findSkin("heads/head_" + head));
        skin.addSkin(this.spine.skeleton.data.findSkin("cores/core_" + scales));
        skin.addSkin(this.spine.skeleton.data.findSkin("tails/tail_" + tail));
        skin.addSkin(this.spine.skeleton.data.findSkin("wings/wings_" + wings));
        skin.addSkin(this.spine.skeleton.data.findSkin("items_hat/item_hat_" + hat));
        skin.addSkin(this.spine.skeleton.data.findSkin("items_neck/item_neck_" + collar));
        skin.addSkin(this.spine.skeleton.data.findSkin("items_tail/item_tail_" + band));
        this.spine.skeleton.setSkin(skin);
        this.spine.update(0);
        var bodyFilters = [new color_filter_1.default(customize_1.CUSTOMIZE_CATEGORIES["body"].elements[body].color)];
        if (dirty) {
            var desaturateFilter = new PIXI.filters.ColorMatrixFilter;
            desaturateFilter.saturate(-0.5, false);
            bodyFilters.push(desaturateFilter);
        }
        var eyeFilters = [new color_filter_1.default(customize_1.CUSTOMIZE_CATEGORIES["eyes"].elements[eyes].color)];
        for (var i = 0; i < this.spine.skeleton.slots.length; i++) {
            var slot = this.spine.skeleton.slots[i];
            switch (this.typeOfSlot(slot)) {
                case SLOT_TYPE.EYE:
                    this.applyFiltersToSlot(eyeFilters, slot);
                    break;
                case SLOT_TYPE.BODY:
                    this.applyFiltersToSlot(bodyFilters, slot);
                    break;
                case SLOT_TYPE.DIRT:
                    slot.color = new PIXI.spine.core.Color(1, 1, 1, dirty ? 1 : 0);
                    break;
            }
        }
        this.setIdleAnimation();
    };
    DragonContainer.prototype.setHatched = function (hatched) {
        if (hatched == this._hatched) {
            return;
        }
        this._hatched = hatched;
        this.setIdleAnimation();
    };
    DragonContainer.prototype.setIdleAnimation = function () {
        var _a;
        var animationName;
        if (!this._hatched) {
            animationName = "egg_idle";
        }
        else if (this._disappointed) {
            animationName = "unwell_idle";
        }
        else {
            animationName = "idle";
        }
        if (((_a = this.spine.state.getCurrent(0)) === null || _a === void 0 ? void 0 : _a.animation.name) == animationName) {
            return;
        }
        var entry = this.spine.state.setAnimation(0, animationName, true);
        entry.mixDuration = 1;
        entry.trackTime = (0, random_1.randomNumber)(entry.animation.duration * 1000) / 1000;
    };
    DragonContainer.prototype.setRubAnimation = function () {
        var _a;
        if (!this._hatched) {
            return;
        }
        var animationName = "rub";
        if (((_a = this.spine.state.getCurrent(0)) === null || _a === void 0 ? void 0 : _a.animation.name) == animationName) {
            return;
        }
        var entry = this.spine.state.setAnimation(0, animationName, true);
        entry.mixDuration = 1;
    };
    DragonContainer.prototype.setRoarAnimation = function (breath) {
        var _a;
        if (!this._hatched) {
            return;
        }
        var animationName = this._disappointed ? "cough" : "roar";
        if (((_a = this.spine.state.getCurrent(0)) === null || _a === void 0 ? void 0 : _a.animation.name) == animationName) {
            return;
        }
        var entry = this.spine.state.setAnimation(0, animationName, false);
        entry.mixDuration = 0.5;
        entry.listener = {
            event: function (entry, event) {
                if (event.data.name == "roar_breath_on") {
                    breath(true);
                }
                else if (event.data.name == "roar_breath_off") {
                    breath(false);
                }
            }
        };
        entry = this.spine.state.addAnimation(0, this._disappointed ? "unwell_idle" : "idle", true, 0);
        entry.mixDuration = 0.5;
    };
    DragonContainer.prototype.setBreatheAnimation = function (repeat, inhaleDuration, exhaleDuration, startInhale, startExhale) {
        if (!this._hatched) {
            return;
        }
        for (var i = 0; i < repeat; i++) {
            if (i == 0) {
                var entry_1 = this.spine.state.setAnimation(0, "breathe_in", false);
                entry_1.timeScale = (entry_1.animation.duration * 1000) / inhaleDuration;
                entry_1.mixDuration = 1;
                startInhale();
            }
            else {
                var entry_2 = this.spine.state.addAnimation(0, "breathe_in", false, 0);
                entry_2.timeScale = (entry_2.animation.duration * 1000) / inhaleDuration;
                entry_2.listener = {
                    start: function (entry) {
                        startInhale();
                    }
                };
            }
            var entry = this.spine.state.addAnimation(0, "breathe_out", false, 0);
            entry.timeScale = (entry.animation.duration * 1000) / exhaleDuration;
            entry.listener = {
                start: function (entry) {
                    startExhale();
                }
            };
        }
    };
    DragonContainer.prototype.typeOfSlot = function (slot) {
        for (var key in SLOT_TYPE) {
            var value = SLOT_TYPE[key];
            if (slot.data.name.startsWith(value + "_")) {
                return value;
            }
        }
        return null;
    };
    DragonContainer.prototype.applyFiltersToSlot = function (filters, slot) {
        var sprite = slot.currentSprite;
        if (sprite) {
            sprite.filters = filters;
        }
        var mesh = slot.currentMesh;
        if (mesh) {
            mesh.filters = filters;
        }
    };
    return DragonContainer;
}(PIXI.Container));
exports.default = DragonContainer;
